import {Component, OnInit} from '@angular/core';
import {VerbrauchsanalyseAusstiegComponent} from '../../verbrauchsanalyse/verbrauchsanalyse.ausstieg.component';
import {StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';
import {WpcheckAnfrage} from '../anfrage/wpcheck.anfrage';
import {WpcheckRequestService} from '../services/request.service';

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-wpcheck-ausstieg',
    templateUrl: './../../verbrauchsanalyse/verbrauchsanalyse.ausstieg.component.html',
    standalone: false
})
export class WpcheckAusstiegComponent extends VerbrauchsanalyseAusstiegComponent implements OnInit {

  /**
   * The last step were we should navigate with the back button to.
   */
  lastStep: string = '../../eingabe';

  /**
   * the anfrage object with the input of the user
   */
  anfrage: WpcheckAnfrage;

  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService,
              protected portalService: PortalService, protected requestService: WpcheckRequestService) {
    super(stepService, router, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.anfrage = this.requestService.getAnfrage();
    this.anfrage.verbrauchsanalyseInput = this.anfrage.userInput;
    this.textkeyPrefix = 'wpcheck';

    super.ngOnInit();
  }
}
